<template>
    <v-layout row justify-center v-if="visible">
        <v-card elevation="0" style="max-width: 1000px;">
            <v-card-title>
                <h3>{{ $t("profilingMachine") }}</h3>
            </v-card-title>
            <v-card-text>
                <v-layout wrap dense>
                    <v-flex xs12 sm3 mr-3>
                        <v-text-field
                            :label="`${$t('maxProfilingDepth')}, ${$t('mm')}`"
                            :hint="`${$t('maxProfilingDepth')}, ${$t('mm')}`"
                            :rules="[rules.required, rules.maxDepth]"
                            @change="changeHandler"
                            v-model="maxDepth.val"
                            ref="maxDepth"
                            required
                            dense
                        ></v-text-field>
                        <v-text-field
                            :label="`${$t('maxSideBoardsAmount')}`"
                            :hint="`${$t('maxSideBoardsAmount')}`"
                            :rules="[rules.required, rules.maxSideBoardsAmount]"
                            @change="changeHandler"
                            v-model="maxSideBoardsAmount.val"
                            ref="maxSideBoardsAmount"
                            required
                            dense
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3>
                        <v-text-field
                            :label="`${$t('centralBoardsMinTotalThickness')}, ${$t('mm')}`"
                            :hint="`${$t('centralBoardsMinTotalThickness')}, ${$t('mm')}`"
                            :rules="[rules.required, rules.centralBoardsMinTotalThickness]"
                            @change="changeHandler"
                            v-model="centralBoardsMinTotalThickness.val"
                            ref="centralBoardsMinTotalThickness"
                            required
                            dense
                        ></v-text-field>
                    </v-flex>

                    <v-divider vertical class="mx-3"></v-divider>

                    <v-flex xs12 sm4>
                        <v-layout wrap dense>
                            <v-checkbox
                                v-model="useCleanSaws"
                                @change="changeHandler"
                                :label="$t('cleanSawsUsed')"
                                hide-details
                                dense
                            ></v-checkbox>
                            <v-flex xs12 class="mt-2">
                                <v-text-field
                                    :label="$t('cleanKerf')"
                                    :hint="`${$t('kerf')}, ${$t('mm')}`"
                                    :suffix="$t('mm')"
                                    :rules="[rules.required, rules.cleanKerf]"
                                    @change="changeHandler"
                                    v-model="cleanKerf.val"
                                    required
                                    dense
                                    :disabled="!useCleanSaws"
                                    ref="cleanKerf"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                 </v-layout>
            </v-card-text>
        </v-card>
    </v-layout>
</template>

<script>
    export default {
        name: "ProfilingSettings",

        data () {
            return {
                changed:             false,
                checkingInput:       false,
                disableWatch:        false,
                maxDepth:            { val: 0, min: 0, max: 0 },
                maxSideBoardsAmount: { val: 0, min: 0, max: 0 },
                centralBoardsMinTotalThickness: { val: 0, min: 0, max: 0 },
                useCleanSaws: false,
                cleanKerf: { val: 0, min: 0, max: 0 },
                rules: {
                    required:            value => !!value || this.$t("requiredField"),
                    maxDepth:            value => (value >= this.maxDepth.min && value <= this.maxDepth.max) || this.$t("incorrectValue"),
                    maxSideBoardsAmount: value => (value >= this.maxSideBoardsAmount.min && value <= this.maxSideBoardsAmount.max) || this.$t("incorrectValue"),
                    centralBoardsMinTotalThickness: value => (value >= this.centralBoardsMinTotalThickness.min && value <= this.centralBoardsMinTotalThickness.max) || this.$t("incorrectValue"),
                    cleanKerf:             value => (value >= this.cleanKerf.min && value <= this.cleanKerf.max) || this.$t("incorrectValue")
                },
                visible: false
            }
        },

        watch: {
            visible: function (val) { this.changed = val ? false : this.changed; }
        },

        methods: {
            /**
             * Обработчик изменений
             */
            changeHandler () {
                if (!this.disableWatch) { this.changed = true; }
            }
        }
    }
</script>
